
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.833 1.5c.428 0 .78.322.828.736l.006.097V6.5h4.166c.428 0 .78.322.828.736l.006.097c0 .428-.322.78-.736.828l-.098.006h-5a.833.833 0 01-.827-.736L0 7.333v-5c0-.46.373-.833.833-.833zM19.167 9.833c.427 0 .78.322.827.736l.006.098v5a.833.833 0 01-1.661.097l-.006-.097V11.5h-4.166a.833.833 0 01-.828-.736l-.006-.097c0-.428.322-.78.736-.828l.098-.006h5z"}}),_c('path',{attrs:{"d":"M19.774 10.096c.29.31.3.783.035 1.102l-.072.076-3.848 3.615a8.333 8.333 0 01-13.75-3.111.833.833 0 011.572-.556 6.667 6.667 0 0010.84 2.642l.178-.171 3.867-3.634a.833.833 0 011.178.037zM11.844.874a8.333 8.333 0 016.017 5.348.833.833 0 01-1.572.556A6.667 6.667 0 005.45 4.136l-.178.171-3.867 3.634A.833.833 0 01.191 6.802l.072-.076L4.11 3.111A8.333 8.333 0 0111.844.874z"}})])])
          )
        }
      }
    